/* Bunico — sıralama seçicilerini eşit tutma (Codex D20-1 ve D21-1, 1 Ekim 2026).
   Koleksiyon sayfasında iki filtre formu var: Bunico araç çubuğu (masaüstü; 1024 px altında yalnız Renk satırı görünür)
   ve temanın "Filtrele ve sırala" çekmecesi. Temanın filtre JS'i (component-facets.js) gönderimi olayın geldiği formun
   alanlarıyla kurar ve sıralama seçicilerini birbirine eşitlemez; çekmecede seçilen sıralama, üst renk satırından
   yapılan bir sonraki seçimde masaüstü formun eski sort_by değeriyle eziliyordu.
   Bu betik sayfadaki bütün sort_by seçicilerini son uygulanan sıralamayla eşit tutar:
   1) kullanıcı bir seçici değiştirince (yakalama aşamasında, temanın gönderiminden önce) diğerleri aynı değere gelir;
   2) tema adresi güncelleyince (filtre sonucu) ve geri/ileri gezinmede adresteki sort_by esas alınır; adreste sort_by
      yoksa koleksiyonun gerçek varsayılanı (bölüm kökündeki data-bn-default-sort = collection.default_sort_by) kullanılır
      (D21-1: parametresiz ilk kayda geri dönüşte seçiciler eski değerde kalıyordu; varsayılan koleksiyona göre değişir,
      örn. Köpek koleksiyonunda created-descending).
   Programatik değer ataması olay üretmez; tema yeniden gönderim yapmaz. Kod yalnız koleksiyon bölümünde yüklenir. */
(() => {
  const seciciler = () => document.querySelectorAll('facet-filters-form [name="sort_by"]');
  const varsayilan = () => {
    const kok = document.getElementById('main-collection-product-grid');
    return kok && kok.dataset.bnDefaultSort ? kok.dataset.bnDefaultSort : null;
  };
  const esitle = (deger, kaynak) => {
    if (!deger) return;
    seciciler().forEach((s) => {
      if (s === kaynak || s.value === deger) return;
      if (Array.prototype.some.call(s.options, (o) => o.value === deger)) s.value = deger;
    });
  };
  const kullaniciSecti = (e) => {
    const t = e.target;
    if (t && t.name === 'sort_by' && t.closest('facet-filters-form')) esitle(t.value, t);
  };
  document.addEventListener('input', kullaniciSecti, true);
  document.addEventListener('change', kullaniciSecti, true);

  const adrestenEsitle = () => esitle(new URLSearchParams(window.location.search).get('sort_by') || varsayilan());
  window.addEventListener('popstate', adrestenEsitle);
  const pushState = history.pushState;
  history.pushState = function () {
    const sonuc = pushState.apply(this, arguments);
    adrestenEsitle();
    return sonuc;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adrestenEsitle);
  else adrestenEsitle();
})();
